import { Navigate } from "react-router-dom";
import { isAdmin, isInstructor, getRole } from "@/lib/auth";

export function ProtectedAdminRoute({ children }) {
  if (!isAdmin()) {
    // If logged in as instructor, redirect them out
    if (isInstructor()) return <Navigate to="/instructor" replace />;
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

export function ProtectedInstructorRoute({ children }) {
  if (!isInstructor()) {
    if (isAdmin()) return <Navigate to="/admin" replace />;
    return <Navigate to="/instructor/login" replace />;
  }
  return children;
}

export default ProtectedAdminRoute;
